import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalLayoutComponent } from "../modal-layout/modal-layout.component";
import { ButtonComponent } from "../../button/button.component";
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-confirmation',
  imports: [CommonModule, ModalLayoutComponent, ButtonComponent],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss',
})
export class ConfirmationComponent {
  dialogRef = inject(MatDialogRef<ConfirmationComponent>)

  delete() {
    this.dialogRef.close(true);
  }
}
